<script lang="ts" setup>
import type { ComponentHeaderReferenceFragment } from "~~/types/graphql";

useHeaderColor("white");
const route = useRoute();

const props = defineProps<{
  headline: ComponentHeaderReferenceFragment["headline"];
}>();
</script>
<template>
  <header class="header-reference bg-integer-white">
    <div class="outer-space container">
      <div class="grid grid-cols-12 py-25 text-integer-black md:pb-39 md:pt-56">
        <module-block-headline
          :title="
            route.params.slug[0].charAt(0).toUpperCase() +
            route.params.slug[0].slice(1)
          "
          class="col-span-12"
        />
        <h1
          class="col-span-12 mt-2 hyphens-auto font-pixel text-h2 md:col-span-10 md:text-h1 lg:col-span-9 lg:hyphens-manual 2xl:text-h1max"
        >
          {{ props.headline }}
        </h1>
      </div>
    </div>
  </header>
</template>
